import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class FlowProgress extends Component {
  render() {
    let className = cx({
      flowProgress: true,
    });

    return (
      <div className={classnames(className)}>
        <div className="flowProgressContainer">{this.props.children}</div>
      </div>
    );
  }
}
